module.exports = __webpack_public_path__ + "img/img.7278f0c8.png";